module.exports = __webpack_public_path__ + "static/media/syslog.ddd8b9c1.gif";